import { IconProps } from "../../../utils/global-types/global-types";

const ProfileTwoUser = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 19"
      className={className ? className : "w-[18px] h-[19px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M8.75 2a3.33 3.33 0 0 0-3.325 3.325c0 1.799 1.407 3.255 3.241 3.318a.6.6 0 0 1 .154 0h.049a3.317 3.317 0 0 0 3.206-3.318A3.33 3.33 0 0 0 8.75 2M12.306 10.505c-1.953-1.302-5.138-1.302-7.105 0-.889.595-1.379 1.4-1.379 2.261s.49 1.66 1.372 2.247c.98.658 2.268.987 3.556.987s2.576-.329 3.556-.987c.882-.595 1.372-1.393 1.372-2.26-.007-.862-.49-1.66-1.372-2.248"
      ></path>
    </svg>
  );
};

export default ProfileTwoUser;
